import i18n from "i18next"
import { initReactI18next } from "react-i18next"

const fallbackLng = "de"
const modules = import.meta.glob("./locales/*.json", { eager: true, import: "default" })
let resources = {}

Object.keys(modules).forEach((path) => {
    const locale = path.replace("./locales/", "").replace(".json", "")
    resources[locale] = {
        translation: modules[path]
    }
})
const availableLanguages = Object.keys(resources)

i18n
    //.use(Backend) // load translations using http (default public/assets/locals/en/translations)
    //.use(LanguageDetector) // detect user language
    .use(initReactI18next) // pass the i18n instance to react-i18next.
    .init({
        resources,
        fallbackLng: fallbackLng,
        whitelist: availableLanguages,
        debug: false,
        detection: {
            checkWhitelist: false // options for language detection
        },
        interpolation: {
            escapeValue: false // no need for react. it escapes by default
        }
    })

export default i18n
